// extracted by mini-css-extract-plugin
export default {"noEventsFound":"EventsCarousel_noEventsFound__tMBEP"};